export default __webpack_public_path__ + "static/media/add-button.999dc7dd.svg";